import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import * as Constants from '../Shared/Constants.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";

const RelatedLegalManufacturers = ({ globalContext }) => {

    const [selectedLegalManufacturer, setSelectedLegalManufacturer] = useState(-1);
    const [status, setStatus] = useState(null);
    const [isAddingRelatedLegalManufacturers, setIsAddingRelatedLegalManufacturers] = useState(false);
    const [showAddLegalManufacturer, setshowAddLegalManufacturer] = useState(false);

    const compliance_statuses = Constants.ComplianceStatuses;





    
    useEffect(() => {

        if (globalContext.isLoadingItemDetails == false && globalContext.currentItem != null && globalContext.legalManufacturers.length > 0)
            loadRelatedLegalManufacturers();            

    }, [globalContext.isLoadingItemDetails]);





    const loadRelatedLegalManufacturers = () => {

        let url = "/Umbraco/Api/Compliance/LegalManufacturers/?entityId=" + globalContext.currentItem.Id + "&entityType=" + globalContext.entityType;

        let requestOptions = {
            method: 'GET',
        };

        globalContext.setIsLoadingRelatedLegalManufacturers(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                globalContext.setRelatedLegalManufacturers(data);
                
            })
            .catch((error) => {
            })
            .finally(() => {
                globalContext.setIsLoadingRelatedLegalManufacturers(false);
            });

    }

    const showAddLegalManufacturerInputs = () => {
        setshowAddLegalManufacturer(true);
    }


    const handleFilterChange = (e) => {
        setSelectedLegalManufacturer(e.target.value);
    }


    const addRelatedLegalManufacturer = () => {

        let url = "/Umbraco/Api/Compliance/LegalManufacturers/?entityId=" + globalContext.currentItem.Id + "&entityType=" + globalContext.entityType + "&legalManufacturerId=" + selectedLegalManufacturer + "&status=" + status;

        let requestOptions = {
            method: 'POST',
        };

        setIsAddingRelatedLegalManufacturers(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                globalContext.setRelatedLegalManufacturers([data, ...globalContext.relatedLegalManufacturers]);
                
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsAddingRelatedLegalManufacturers(false);
                setshowAddLegalManufacturer(false);
            });

    }



    const loadRelatedLegalManufacturerItem = (id) => {

        globalContext.loadItemDetails(id);

    }

    const existingRelatedLegalManufacturersIds = new Set(globalContext.relatedLegalManufacturers.map(r => r.LegalManufacturerId));

    return (
        <>

            {globalContext.legalManufacturers.length == 0 ? (
                <span></span>
            ) : globalContext.isLoadingRelatedLegalManufacturers && !isAddingRelatedLegalManufacturers ? <div><LoadingSpinnerImage /></div> :
                <>
                        <div className="g-mt-10 g-mb-20" style={{width:"100%"}}>

                   
                            {globalContext.relatedLegalManufacturers.length > 0 ? (
                                <>
                                    <div style={{ display: "flex", flexDirection: "column", width: "100%", marginTop: "10px" }}>
                                        <div style={{ width: "100%", display: "flex", flexDirection: "row", fontSize: "9pt", borderBottom: "1px solid #c0c0c0" }}>
                                            <div style={{ width: "45%", fontWeight: "bold" }}>LEGAL MANUFACTURER</div>
                                            <div style={{ width: "45%", fontWeight: "bold" }}>STATUS</div>
                                            <div style={{ width: "10%", fontWeight: "bold" }}>ACTIONS</div>
                                        </div>

                                        {globalContext.relatedLegalManufacturers.map((rm, index) => {
                                            let legalManufacturer = globalContext.legalManufacturers.find(lm => lm.EstablishmentId == rm.LegalManufacturerId);
                                            let legalManufacturerName = legalManufacturer ? legalManufacturer.Establishment : "";

                                            return (
                                                <div key={index} className="datatable-row" style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                                    <div style={{ width: "45%", padding: "3px 0px", display: "flex", alignItems: "center" }}>{legalManufacturerName}</div>
                                                    <div style={{ width: "45%", padding: "3px 0px", display: "flex", alignItems: "center" }}>
                                                        <FieldTypes.FieldType_Compliance_Status value={rm.Status} />
                                                    </div>
                                                    <div style={{ width: "10%", padding: "3px 0px", display: "flex", alignItems: "center" }}>
                                                        <span
                                                            style={{ cursor: "pointer", borderRadius: "15px", backgroundColor: "#e9f4ff", padding: "3px 7px", fontSize: "11px" }}
                                                            onClick={() => { loadRelatedLegalManufacturerItem(rm.Id); }}
                                                        >
                                                          Select
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            ) : (
                                    <p style={{marginTop:"10px"}}> - Currently there are no legal manufacturers assigned.</p>
                            )}
                            {!showAddLegalManufacturer ? 
                                <div style={{ textAlign: "left", marginTop: "20px" }}>
                                    {globalContext.userRole === "Admin" && (
                                        <button
                                            className="action-button save-button g-font-size-11"
                                            onClick={showAddLegalManufacturerInputs}
                                        >
                                            Add Legal Manufacturer to this Document
                                        </button>
                                    )}</div>
                                        
                                : isAddingRelatedLegalManufacturers ? <div style={{textAlign:"center"} }><LoadingSpinnerImage /></div> : <>
                                    <div style={{ textAlign: "left", marginTop: "40px" }}><p>Select the Legal Manufacturer and the compliance status of this Document</p>
                                        <select
                                            value={selectedLegalManufacturer}
                                            onChange={handleFilterChange}
                                            className="custom-select"
                                            style={{ width: "230px", marginLeft: "3px" }}
                                        >
                                            <option value="-1">Choose a Legal Manufacturer</option>
                                            {globalContext.legalManufacturers
                                                .filter(lm => !existingRelatedLegalManufacturersIds.has(lm.EstablishmentId))
                                                .map(lm => (
                                                    <option key={lm.EstablishmentId} value={lm.EstablishmentId}>
                                                        {lm.Establishment}
                                                    </option>
                                                ))}
                                        </select>
                                <select
                                        value={status}
                                        style={{ width: "230px", marginLeft: "20px" }}
                                        className="custom-select"
                                    onChange={(e) => {
                                        setStatus(e.target.value);
                                    }}
                                    >
                                    {compliance_statuses.map((compliance_status, index) => (
                                        <option key={index} value={compliance_status.id}>
                                            {compliance_status.name}
                                        </option>
                                    ))}
                                        </select><button className="action-button add-task-button g-font-size-11 g-ml-15" onClick={addRelatedLegalManufacturer}>
                                            <span className="fas fa-plus-circle g-mr-5"></span>Add</button>
                                    </div> 
                            </>}
                            


                        </div>
                </>
            }


        </>
    );



}


export default RelatedLegalManufacturers;